import { formatISO } from 'date-fns';


function downloadAsCsv(dataArr, fileName) {
  var dataContent = '';
  dataArr.forEach(function(infoArray, index) {
    let dataString = infoArray.join(',');
    dataContent += index < dataArr.length ? dataString + '\n' : dataString;
  });
  
  var a = document.createElement('a');
  const mimeType = 'text/csv;encoding:utf-8;';

  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(new Blob([dataContent], {
      type: mimeType
    }), fileName);
  } else if (URL && 'download' in a) {
    a.href = URL.createObjectURL(new Blob([dataContent], {
      type: mimeType
    }));
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } else {
    location.href = 'data:application/octet-stream,' + encodeURIComponent(dataContent);
  }
}


export default function downloadData(
  mode,
  loc,
  attrOpts,
  data,
  locationName,
  hYears,
  hazardType,
  hazardRange,
  emissionLowData,
  emissionHighData
) {
  if (mode) {
    let currYear = new Date().getFullYear();

    let csvData = [
      ['Download Date', formatISO(new Date(), { representation: 'date' })],
      ['Location', locationName],
      ['Data', attrOpts.name],
      ['Units', attrOpts.units.trim()],
      [],
      [],
      ['', '', 'Low Emissions Future (RCP 4.5)', '', '', 'High Emissions Future (RCP 8.5)'],
      ['Year', 'Historical', 'Range Minimum', 'Mean', 'Range Maximum', 'Range Minimum', 'Mean', 'Range Maximum']
    ];
    
    if (hYears[hYears.length - 1] === new Date().getFullYear()) {
      hYears.pop();
    }

    hYears.forEach((year, i) => {
      if (data[i] || data[i] === 0) {
        csvData.push([year, data[i]]);
      }
    });

    emissionLowData.lower.x.forEach((year, index) => {
      let nYear = parseInt(year);
      if (nYear >= currYear) {
        csvData.push([
          nYear,
          '',
          emissionLowData.lower.y[index],
          emissionLowData.mean.y[index],
          emissionLowData.upper.y[index],
          emissionHighData.lower.y[index],
          emissionHighData.mean.y[index],
          emissionHighData.upper.y[index]
        ]);
      }
    });

    downloadAsCsv(csvData, `${locationName}-climate-data.csv`);
  } else {
    data = Object.keys(data).reduce((acc, impact, i) => {
      let impactData = data[impact][loc.id] || [];
      
      let index;
      switch (impact) {
      case 'count':
        index = 1;
        break;
      case 'damageCrops':
        index = 2;
        break;
      case 'damageProperty':
        index = 3;
        break;
      case 'deaths':
        index = 4;
        break;
      case 'injuries':
        index = 5;
        break;
      }

      if (index) {
        for (let year = hazardRange.min; year < hazardRange.max + 1; year++) {
          if (i === 0) {
            acc.push([year, null, null, null, null, null]);
          }
          
          let found = impactData.find(arr => arr[0] === year);

          if (found) {
            acc[year - hazardRange.min][index] = found[1];
          } else {
            acc[year - hazardRange.min][index] = 0;
          }
        }
      }
      
      return acc;
    }, []);

    let header = [
      ['Download Date', formatISO(new Date(), { representation: 'date' })],
      ['Location', locationName],
      ['Data', hazardType],
      [],
      [],
      ['Year', 'Total Reported Episodes', 'Reported Crop Damage (USD)', 'Reported Property Damage (USD)', 'Total Reported Deaths', 'Total Reported Injuries']
    ];

    data = data.sort((a,b) => a[0] - b[0]);

    downloadAsCsv([ ...header, ...data], `${locationName}-${hazardType}.csv`);
  }
}